export default __webpack_public_path__ + "static/media/thumbs-up.86ccd7e0.png";